import { useContext, useRef } from "react";
import Draggable from "react-draggable";
import { stateContext } from "./ctx";
import {getDraggedPixels,placeDragger} from './functions'

const Hue = () => {
    const {setHue,setSession,hue} = useContext(stateContext)
    const hueRef = useRef(null)

    

	const hueChange = e => setHue(getDraggedPixels(e.clientX,hueRef.current,360))

    return <div className='flex flex-1 items-center gap-5 h-16'>
        
        <div ref={hueRef} className='flex-1 raimbow rounded-full w-full h-1 relative'>
            <Draggable onStop={()=>setSession(Date.now())} position={{x:placeDragger(hue,hueRef.current,360),y:0}} axis='x' bounds="parent" onDrag={hueChange}>
                <div className='handle'></div>
            </Draggable>        
        </div>
        <input type='number' className='input' value={hue} onChange={e=>setHue(e.target.value)} />
        
    </div>
}

export default Hue